import classNames from 'classnames'
import { FormikProps, useField, useFormikContext } from 'formik'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import BaseSelect, { OptionType } from 'shared/components/base/form/base-select'
import BaseLabel, {
  BaseLabelProps,
} from 'shared/components/base/form/BaseLabel'
import dictionary from 'shared/constants/dictionary'
import { useEmit } from 'shared/contexts/socket/socket-context'

import { formikValuesType } from '../submit-phone-call/sales-person-call-submission'
import CustomerSearchInput from './customer-search-input'

export type InputWithPreNamePropType = {
  preNameFieldName: string
  nameFieldName: string
  preNameValue?: string
  nameValue?: string
  className?: string
  label?: string
  labelProps?: BaseLabelProps
  selectClassName?: string
}

const textClassName = 'font-normal text-[14px] leading-[32px] text-color-title'

export const InputWithPreName = (props: InputWithPreNamePropType) => {
  const {
    preNameFieldName,
    nameFieldName,
    className,
    label,
    labelProps,
    selectClassName,
    ...rest
  } = props
  const [preNameOptions, setPreNameOptions] = useState<OptionType<number>[]>([])
  const emit = useEmit()
  const [isContactNew, setIsContactNew] = useState<boolean>(false)

  // ------------------------------- use field ----------------------
  const [preNameField, , preNameMeta] = useField({
    name: preNameFieldName,
  })
  const [nameField, , nameMeta] = useField({
    name: nameFieldName,
  })

  // -------------------------------end  use field ----------------------

  const { setFieldValue } = useFormikContext<FormikProps<formikValuesType>>()

  useEffect(() => {
    emit('getLeadPreNames')
      .then((options?: { label: string; value: number }[]) => {
        if (!options) {
          toast.error(dictionary.socket_timeout)
          return
        }

        options.sort((a, b) => {
          if (a.label === 'حاج آقا') return 1
          if (b.label === 'حاج آقا') return -1
          return a.label <= b.label ? -1 : 1
        })
        const _options = options.map((item) => ({
          ...item,
          key: item.value,
        }))
        setPreNameOptions(_options)
      })
      .catch(() => {
        toast.error(dictionary.socket_timeout)
      })
  }, [])

  return (
    <>
      {label && <BaseLabel {...labelProps}>{label}</BaseLabel>}

      <div className={classNames('flex ', className)} {...rest}>
        {/*--------------------------pre name ---------------------------*/}
        <BaseSelect<any>
          {...preNameField}
          limitOptionsHeight={false}
          options={preNameOptions}
          value={preNameField.value?.value}
          className={classNames(
            'w-[45%] rounded-none rounded-l-none ',
            selectClassName
          )}
          setInputClassName={() => classNames('rounded-l-none !h-10')}
          onSelect={(value, node) => preNameMeta.setValue(node)}
        />
        {/*--------------------------end pre name ---------------------------*/}

        {/*---------------------------------name-------------------------*/}
        <CustomerSearchInput
          {...nameField}
          inputClassName={classNames(
            '!border-r-none min-h-[2.5625rem] border-r-0 rounded-r-none !h-10',
            textClassName
          )}
          value={nameField?.value}
          setIsNew={(value) => {
            if (value === true) {
              setIsContactNew(value)
              setFieldValue('lead', {
                ...nameField.value,
                id: '',
                type: 'lead',
              })
            }
          }}
          isNew={isContactNew}
          onSelect={(e) => {
            nameMeta?.setValue(e)
          }}
          onChangeInput={(event) => {
            nameMeta?.setValue({
              ...nameField.value,
              name: event?.target?.value,
            })
          }}
        />
        {/*--------------------------------- end name-------------------------*/}
      </div>
    </>
  )
}
